import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.join.js";
import business_0 from "../assets/images/bizEmoji/business_0.png";
import business_1 from "../assets/images/bizEmoji/business_1.png";
import business_2 from "../assets/images/bizEmoji/business_2.png";
import business_3 from "../assets/images/bizEmoji/business_3.png";
import business_4 from "../assets/images/bizEmoji/business_4.png";
import business_5 from "../assets/images/bizEmoji/business_5.png";
import business_6 from "../assets/images/bizEmoji/business_6.png";
import business_7 from "../assets/images/bizEmoji/business_7.png";
import business_8 from "../assets/images/bizEmoji/business_8.png";
import uniq from "lodash/uniq";
import difference from "lodash/difference";
import { Emoji } from "../assets/sprites/emoji";
import { IS_DEV } from "./fhtGlobalEnv";
export var biz_emoji_map = {
  business_0: business_0,
  business_1: business_1,
  business_2: business_2,
  business_3: business_3,
  business_4: business_4,
  business_5: business_5,
  business_6: business_6,
  business_7: business_7,
  business_8: business_8
};
export var SIMPLE_EMOJI_KEYS_WITH_ORDER = ["smile", "laugh_with_teeth", "laugh", "kiss", "sun_glasses", "happy", "bye", "cash", "greedy", "covet", "lovely", "love_you", "sweat", "contempt", "sick", "blush", "pitiful", "weep", "tears", "shut_up", "titter", "wronged", "pick_nose", "hiss", "think", "doubt", "giddy", "disappointed", "bookworm", "grimace", "awkward", "astonished", "decline", "go_mad", "sinister", "angry", "hum_left", "hum_right", "hum", "not_bother_you", "yawn", "sleep", "clap", "ill", "catch_cold", "sleepy", "go_crazy", "rage", "pig", "withstand_pressure", "thumb_up_support", "finger_yeah", "finger_ok", "hank_shake", "finger_love_you", "finger_no", "thumb_up", "thumb_down", "finger_come", "hand_come_on", "heart_unbroken", "heart_broken", "chess_commander", "red_packet", "gelivable"];

if (IS_DEV) {
  if (uniq(SIMPLE_EMOJI_KEYS_WITH_ORDER).length !== SIMPLE_EMOJI_KEYS_WITH_ORDER.length) {
    throw new Error("have duplicate entries in simpleEmojis");
  }

  var missing = difference(Object.keys(Emoji), SIMPLE_EMOJI_KEYS_WITH_ORDER);

  if (missing.length) {
    throw new Error("You must have missed some keys: " + missing.join(", "));
  }
}